/**
 * Created by Fayaz on 2/22/2018.
 */
import {Injectable} from '@angular/core';
import { ToasterModule, ToasterService, ToasterConfig }  from 'angular2-toaster/angular2-toaster';

@Injectable()
export class TosterMessageService {

    constructor(private toasterService:ToasterService){

    }

    showSuccess(title,message) {
        this.toasterService.pop('success',title,message);
    }

    showError(title,message) {
        this.toasterService.pop('error',title,message);
    }

    showWarning(title,message) {
        this.toasterService.pop('warning',title,message);
    }

    showInfo(title,message) {
        this.toasterService.pop('info',title,message);
    }

    showPrimary(title,message) {
        this.toasterService.pop('primary',title,message);
    }

    showList(title,message) {
      var a = "pasan<br>maduranga";
      this.toasterService.pop('success',title,a);
    }


}



// WEBPACK FOOTER //
// /app/src/app/services/toster-message.service.ts